import { useEffect, useRef } from 'react'

import { cap } from '../../../../State'
import { translations } from '../../../../translations'
import { Icon } from '../Icons'
import { useGigiFormValidation } from '../ValidationContext'

const language = cap.language.state || 'IT'
const t = translations[language]

export const SectionNav = ({ sections = [], activeId, onPillClick }) => {
  const { sectionHasErrors } = useGigiFormValidation()
  const navRef = useRef(null)
  const visible = sections.filter((s) => s.visible !== false)

  useEffect(() => {
    const nav = navRef.current
    if (!nav) return
    const activeEl = nav.querySelector('.gf-pill.is-active')
    if (!activeEl) return
    const navRect = nav.getBoundingClientRect()
    const pillRect = activeEl.getBoundingClientRect()
    if (pillRect.left < navRect.left || pillRect.right > navRect.right) {
      const scrollLeft =
        activeEl.offsetLeft - nav.offsetLeft - navRect.width / 2 + pillRect.width / 2
      nav.scrollTo({ left: scrollLeft, behavior: 'smooth' })
    }
  }, [activeId])

  if (visible.length < 2) return null

  return (
    <nav aria-label={t.gfSezioniForm} className="gf-secnav" ref={navRef}>
      {visible.map((s) => {
        const hasErrors = sectionHasErrors(s.id)
        const showCount = typeof s.count === 'number' && s.count > 0
        const isActive = activeId === s.id
        return (
          <button
            type="button"
            key={s.id}
            className={[
              'gf-pill',
              isActive ? 'is-active' : '',
              hasErrors ? 'has-error' : '',
              !hasErrors && s.complete ? 'has-ok' : ''
            ]
              .filter(Boolean)
              .join(' ')}
            onClick={() => onPillClick?.(s.id)}
            aria-label={s.title + (hasErrors ? ` (${t.gfContieneErrori})` : '')}
          >
            {s.icon && <Icon name={s.icon} size={13} />}
            <span>{s.shortTitle || s.title}</span>
            {showCount && <span className="gf-pill__count">{s.count}</span>}
            {hasErrors && <span className="gf-pill__dot" title={t.gfContieneErroriTitle} />}
            {!hasErrors && s.complete && <Icon name="check" size={11} className="gf-pill__check" />}
          </button>
        )
      })}
    </nav>
  )
}
